import React, { useState } from 'react';
import { XMarkIcon, CheckIcon, MagnifyingGlassIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';

export default function EditarEstrategia({
    showForm,
    onClose,
    onSave,
    formData,
    onInputChange,
    editingId,
    selectResultadoData,
    carteras,
    riesgoData
}) {
    const [searchResultado, setSearchResultado] = useState('');
    const [errors, setErrors] = useState({});
    
    if (!showForm) return null;

    // Validar formulario
    const validarFormulario = () => {
        const newErrors = {};

        if (!formData.Periodo) {
            newErrors.Periodo = 'El período es requerido';
        }
        if (!formData.idCbo_ResultadoGestion) {
            newErrors.idCbo_ResultadoGestion = 'Debes seleccionar un resultado de gestión';
        }
        if (!formData.idCbo_TipoCartera) {
            newErrors.idCbo_TipoCartera = 'Debes seleccionar un tipo de cartera';
        }
        if (!formData.idCbo_Riesgo) {
            newErrors.idCbo_Riesgo = 'Debes seleccionar un nivel de riesgo';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleGuardar = () => {
        if (validarFormulario()) {
            onSave();
            setErrors({});
        }
    };

    // Filtrar resultados según búsqueda
    const filteredResultados = selectResultadoData?.filter(item =>
        item.Estado.toLowerCase().includes(searchResultado.toLowerCase())
    ) || [];

    return (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-md z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-700 via-blue-600 to-cyan-600 px-8 py-6 flex items-center justify-between sticky top-0">
                    <h2 className="text-2xl font-black text-white">
                        {editingId ? '✏️ Editar Estrategia' : '✨ Nueva Estrategia'}
                    </h2>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-white/20 rounded-lg transition-colors"
                    >
                        <XMarkIcon className="w-6 h-6 text-white" />
                    </button>
                </div>

                {/* Contenido */}
                <div className="p-8 space-y-6">
                    {/* Período - Fila completa */}
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">
                            Período *
                        </label>
                        <input
                            type="date"
                            name="Periodo"
                            value={formData.Periodo}
                            onChange={onInputChange}
                            disabled={!!editingId}
                            className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2 font-semibold transition-all ${
                                errors.Periodo
                                    ? 'border-red-500 focus:border-red-500 focus:ring-red-200 bg-red-50'
                                    : editingId
                                    ? 'border-gray-200 bg-gray-100 cursor-not-allowed opacity-60'
                                    : 'border-gray-200 focus:border-blue-500 focus:ring-blue-200'
                            }`}
                        />
                        {errors.Periodo && (
                            <p className="text-red-500 text-sm font-semibold mt-1 flex items-center gap-1">
                                <ExclamationCircleIcon className="w-4 h-4" />
                                {errors.Periodo}
                            </p>
                        )}
                    </div>

                      <div className="grid grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">
                                Tipo de Cartera *
                            </label>
                            <select
                                name="idCbo_TipoCartera"
                                value={formData.idCbo_TipoCartera}
                                onChange={onInputChange}
                                disabled={!formData.Periodo}
                                className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2 font-semibold transition-all ${
                                    errors.idCbo_TipoCartera
                                        ? 'border-red-500 focus:border-red-500 focus:ring-red-200 bg-red-50'
                                        : formData.Periodo
                                        ? 'border-gray-200 focus:border-blue-500 focus:ring-blue-200 bg-white cursor-pointer'
                                        : 'border-gray-200 bg-gray-100 cursor-not-allowed opacity-50'
                                }`}
                            >
                                <option value="">Selecciona período...</option>
                                {carteras && carteras.length > 0 && carteras.map(c => (
                                    <option key={c.idCbo_TipoCartera} value={c.idCbo_TipoCartera}>
                                        {c.Cartera} (Días {c.Desde}-{c.Hasta})
                                    </option>
                                ))}
                            </select>
                            {errors.idCbo_TipoCartera && (
                                <p className="text-red-500 text-sm font-semibold mt-1 flex items-center gap-1">
                                    <ExclamationCircleIcon className="w-4 h-4" />
                                    {errors.idCbo_TipoCartera}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">
                                Nivel de Riesgo *
                            </label>
                            <select
                                name="idCbo_Riesgo"
                                value={formData.idCbo_Riesgo}
                                onChange={onInputChange}
                                className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2 font-semibold transition-all ${
                                    errors.idCbo_Riesgo
                                        ? 'border-red-500 focus:border-red-500 focus:ring-red-200 bg-red-50'
                                        : 'border-gray-200 focus:border-blue-500 focus:ring-blue-200'
                                }`}
                            >
                                <option value="">Selecciona riesgo...</option>
                                {riesgoData && riesgoData.length > 0 && riesgoData.map(r => (
                                    <option key={r.idCbo_Riesgo || r.id} value={r.idCbo_Riesgo || r.id}>{r.Riesgo || r.nombre}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">
                            Resultado de Gestión *
                        </label>
                        
                        {/* Campo de búsqueda */}
                        <div className="relative mb-3">
                            <MagnifyingGlassIcon className="absolute left-3 top-3.5 w-5 h-5 text-gray-400" />
                            <input
                                type="text"
                                placeholder="Buscar resultado..."
                                value={searchResultado}
                                onChange={(e) => setSearchResultado(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 font-semibold text-sm uppercase"
                            />
                        </div>

                        {/* Select con opciones filtradas */}
                        <select
                            name="idCbo_ResultadoGestion"
                            value={formData.idCbo_ResultadoGestion || ''}
                            onChange={(e) => {
                                onInputChange(e);
                                setSearchResultado(''); // Limpiar búsqueda al seleccionar
                            }}
                            className={`w-full px-4 py-4 border-2 rounded-lg focus:outline-none focus:ring-2 font-semibold text-base transition-all ${
                                errors.idCbo_ResultadoGestion
                                    ? 'border-red-500 focus:border-red-500 focus:ring-red-200 bg-red-50'
                                    : 'border-gray-200 focus:border-blue-500 focus:ring-blue-200'
                            }`}
                        >
                            <option value="">→ Seleccionar resultado de gestión...</option>
                            {filteredResultados && filteredResultados.length > 0 ? (
                                filteredResultados.map((item) => (
                                    <option key={item.idCbo_ResultadoGestion} value={item.idCbo_ResultadoGestion}>
                                        {item.Estado}
                                    </option>
                                ))
                            ) : searchResultado ? (
                                <option disabled>No hay resultados</option>
                            ) : null}
                        </select>
                        {errors.idCbo_ResultadoGestion && (
                            <p className="text-red-500 text-sm font-semibold mt-1 flex items-center gap-1">
                                <ExclamationCircleIcon className="w-4 h-4" />
                                {errors.idCbo_ResultadoGestion}
                            </p>
                        )}
                    </div>
                    <div className="grid grid-cols-2 gap-6"></div>
                </div>

                {/* Footer */}
                <div className="bg-gray-100 px-8 py-4 flex items-center justify-end gap-3 border-t border-gray-200 rounded-b-2xl sticky bottom-0">
                    <button
                        onClick={onClose}
                        className="px-6 py-3 bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold rounded-lg transition-all"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleGuardar}
                        className="px-6 py-3 bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white font-bold rounded-lg transition-all flex items-center gap-2"
                    >
                        <CheckIcon className="w-5 h-5" />
                        Guardar
                    </button>
                </div>
            </div>
        </div>
    );
}
